import GenericFilter, { Item } from "@/components/Filters/GenericFilter";
import { IconBolt } from "@tabler/icons-react";

export default function CounterFilter({
  selected,
  setSelected,
}: {
  selected: Set<any>;
  setSelected: (selectedOptions: Set<string>) => void;
}) {
  let data: Item[] = [];
  for (let i = 0; i < 3; i++) {
    let power = i * 1000;
    data.push({ key: String(power), value: String(power) });
  }
  return (
    <GenericFilter
      classNames="w-[120px]"
      selected={selected}
      setSelected={setSelected}
      selectionMode="single"
      startContent={<IconBolt />}
      label="Counter"
      data={data}
    />
  );
}
